import React from "react";
import Div from "../../../../../widget/common/ui/Div";
import { CheckBoxRound } from "../../../../../widget/common/ui/Checkbox";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { ResponsiveDeviceType } from "../../../../../widget/layouts/ScreenMedia";
import {
  RecoverPasswordEmailField,
  RecoverPhoneField,
} from "./RecoverPaswordTextfields";
import { SpacingHeight } from "../../../../../widget/common/ui/Spacing";
import { RecoverPasswordContextImport } from "../../../../../provider/onboarding/forgot_password/recover_password/RecoverPasswordContextProvider";

const RecoverPasswordTypeSelection = () => {
  const type: number = ResponsiveDeviceType();

  const { flag, handleChangeFlagType } = RecoverPasswordContextImport();

  const optionHtml = ({
    label = "",
    status = false,
    onClick,
  }: {
    label: string;
    status: boolean;
    onClick: () => void;
  }): JSX.Element => {
    return (
      <div
        role="button"
        className="d-flex align-items-center"
        onClick={onClick}
      >
        <CheckBoxRound status={status} />
        <span className="ps-2">{AppTranslation.text(label)}</span>
      </div>
    );
  };

  return (
    <Col md={8} className="mx-auto">
      <Div
        className={`d-flex align-items-center ${
          type === 3 ? "justify-content-around" : "justify-content-between"
        }`}
      >
        {optionHtml({
          label: "email",
          status: flag === "0",
          onClick: () => handleChangeFlagType("0"),
        })}
        {optionHtml({
          label: "phone_number",
          status: flag === "1",
          onClick: () => handleChangeFlagType("1"),
        })}
      </Div>

      <SpacingHeight value={type === 1 ? 35 : type === 2 ? 48 : 45} />

      {flag === "1" ? <RecoverPhoneField /> : <RecoverPasswordEmailField />}
    </Col>
  );
};

export default RecoverPasswordTypeSelection;
